export const POST_TAX = "admin/tax";

export const GET_TAX = "admin/taxList";

export const UPDATE_TAX = "admin/editTax";
